const watchValues = require('./watch-values');

/**
 * Get all current values for a list of paths, filtered for pending values and returned in order,
 * returned as values alone
 * @param {Observable} stream - the output of a muster `get` query
 * @returns {Promise<Array<*>>} - a promise resolving to an array of values,
 * in the order they were requested
 */
function getAll(stream) {
  return watchValues(stream).take(1).toPromise();
}

module.exports = getAll;
